/** URL картки об'єкта / продажу */
export const getObjectCardPath = (objectId: number, onlySale?: boolean | number | null): string => {
    const id = Number(objectId || 0);
    if (!id) return '/objects';
    return Number(onlySale) === 1 || onlySale === true ? `/sales/${id}` : `/objects/${id}`;
};
